// eslint-disable-next-line import/no-amd
define([
    '../../../utils/Globals',
    'jquery',
    'underscore',
    '../../app/models/MabinsoModel'
], (Globals, $, _, MabinsoModel) => {
    const SchemaModel = MabinsoModel.extend({
        backend: true,
        urlRoot: Globals.baseUrl + 'schemas/schema',
        defaults: {
            name: '',
            description: '',
            sclass: '',
            port: '',
            host: '',
            database: '',
            user: '',
            password: ''
        },
        initialize() {
        }
    });

    return SchemaModel;
});




// WEBPACK FOOTER //
// ./src/components/schema/models/SchemaModel.js